export default {
  consciuousDesigner: 'creatives',
  howTO: 'responsible-design'
}
